module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" shipping-change-feature=\"shippingChangeFeature\" render-billing-add-checkbox=\"renderBillingAddCheckbox\" back-uri=\"backUri\" done-uri=\"backUri\"></xo-shipping-address>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html
// module id = ../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html
// module chunks = 0